<template>
    <v-container max-width="100%" style="margin-top: 2%">

      <v-dialog v-model="showLocationDialog" fullscreen>
        <v-card>
            <v-toolbar dark color="primary" ref="myToolbar">
              <v-btn icon dark @click="closeLocationDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ $t('equipStatus.map') }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <div style="width: 90vw; height: 90vh; float: left;">
                <l-map
                  ref="map"
                  :zoom="18"
                  :center="currentCenter"
                  :minZoom="12"
                  :maxZoom="18"
                  @ready="onMapPlotagemResize"
                  :options="mapOptions"
                  v-resize="onMapPlotagemResize"
                  style="border-radius: 10px; margin-top: 5px; z-index: 1">
        
                  <l-tile-layer :url="url" :attribution="attribution" />
                  <l-marker :lat-lng="posicao">
                    <l-tooltip :content="numeroOrdemSelected" :options="{permanent: true, direction: 'top', opacity: 1.0, className: 'veiculo__tooltip'}"></l-tooltip>
                  </l-marker>
                </l-map>
              </div>
            </v-card-text>
          </v-card>
      </v-dialog>
  
        <v-container class="toolbar__container" style="margin-top: 20px;">
          <v-form ref="form">
            <v-row>
                <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                        v-model="veiculoSelected"
                        :items="veiculos"
                        item-text="numero_ordem"
                        item-value="id_veiculo"
                        :label="$t('equipStatus.vehicle')"
                        :loading="loadingVeiculos"
                        :rules="[(v => !!v || $t('equipStatus.selectVehicle'))]"
                    ></v-autocomplete>
                </v-col>
            </v-row>
            <v-row justify="end">
                <v-btn
                  color="primary"
                  heigth="20"
                  dark
                  fab
                  retain-focus-on-click
                  @click="populaConsulta"
                  style="margin-right: 10px;"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                
                <v-btn
                  @click="showLocation"
                  depressed
                  plain
                  :disabled="!status[0] || !status[0].dt_posicao"
                  class="mt-2"
                >
                  <v-icon color="primary" large>mdi-map-marker</v-icon>
                </v-btn>
            </v-row>
          </v-form>
        </v-container>
  
      <v-row class="status-cards-row" no-gutters justify="center" align="stretch">
        <!-- Card Status Validador -->
        <v-col
          cols="12"
          md="6"
          class="d-flex"
          style="padding-right: 8px; margin-bottom: 24px;"
        >
          <v-card class="status-card" style="margin-top: 15px; width: 100%; height: 100%;">
            <v-card-title>
              <span class="headline" color="#4a4a4a">{{ $t('equipStatus.validator.title') }}</span>
            </v-card-title>
            <v-card-text>
              <div v-if="loadingStatus">
                <v-progress-linear
                  :size="50"
                  color="primary"
                  indeterminate
                ></v-progress-linear>
              </div>
              <div v-else>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.validator.model') }}</strong>
                        <span class="ml-2">{{ status[0].modelo || '-' }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.validator.serialNumber') }}</strong>
                        <span class="ml-2">{{ status[0].numero_serie || '-' }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.validator.antenna') }}</strong>
                        <span class="ml-2">{{ status[0].tipo_antena || '-' }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.validator.gpsProtocolVersion') }}</strong>
                        <span class="ml-2">{{ status[0].versao_protocolo_gps || '-' }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.validator.ticketingProtocolVersion') }}</strong>
                        <span class="ml-2">{{ status[0].versao_protocolo_bilhetagem || '-' }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="my-2"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.validator.status') }}</strong>
                        <span class="ml-2">{{ status[0].status_validador || '-' }}</span>
                        <span class="grey--text text--darken-1" style="font-size: 0.9em;">
                          ({{ status[0].dt_estado_validador || '-' }})
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="my-2"></v-divider>
                  <!-- <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>Últimas Posições Válidas:</strong>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <div v-for="(st, i) in status" :key="`pos-${i}`" style="font-size: smaller;">
                          {{ st.dt_posicao || '-' }} <span class="grey--text">{{ st.qualidade_sinal || '' }}</span>
                        </div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item> -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.validator.lastEvents') }}</strong>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <div v-for="(st, i) in status" :key="`eve-${i}`" style="font-size: smaller;">
                          {{ st.dt_evento || '-' }} <span class="grey--text">{{ st.descricao_evento || '' }}</span>
                        </div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.validator.lastTicketing') }}</strong>
                        <span class="ml-2">{{ status[0].dt_bilhetagem || '-' }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.validator.lastGuides') }}</strong>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <div v-for="(st, i) in status" :key="`guia-${i}`" style="font-size: smaller;">
                          {{ st.dt_ultima_guia || '-' }}
                        </div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Card Status AVL -->
        <v-col
          cols="12"
          md="6"
          class="d-flex"
          style="padding-left: 8px; margin-bottom: 24px;"
        >
          <v-card class="status-card" style="margin-top: 15px; width: 100%; height: 100%;">
            <v-card-title>
              <span class="headline" color="#4a4a4a">{{ $t('equipStatus.avl.title') }}</span>
            </v-card-title>
            <v-card-text>
              <div v-if="loadingStatus">
                <v-progress-linear
                  :size="50"
                  color="primary"
                  indeterminate
                ></v-progress-linear>
              </div>
              <div v-else>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.avl.code') }}</strong>
                        <span class="ml-2">{{ status[0].cod_avl || '-' }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.avl.virtualOdometer') }}</strong>
                        <span class="ml-2">{{ status[0].hodometro_virtual != null ? status[0].hodometro_virtual : '-' }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.avl.virtualCollectionDate') }}</strong>
                        <span class="ml-2">{{ status[0].dt_hodometro_virtual || '-' }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.avl.canOdometer') }}</strong>
                        <span class="ml-2">{{ status[0].hodometro_canbus != null ? status[0].hodometro_canbus : '-' }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.avl.canCollectionDate') }}</strong>
                        <span class="ml-2">{{ status[0].dt_hodometro_canbus || '-' }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.avl.odometerDifference') }}</strong>
                        <span class="ml-2">
                          {{
                            (status[0].hodometro_virtual != null && status[0].hodometro_canbus != null)
                              ? ((Number(status[0].hodometro_canbus) - Number(status[0].hodometro_virtual)).toFixed(1))
                              : '-'
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.statusCan') }}</strong>
                        <span class="ml-2">
                          {{ status[0].status_canbus? 'Normal' : 'Anormal' }}
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.statusIgnition') }}</strong>
                        <span class="ml-2">
                          {{ status[0].status_ignicao == 0 ? $t('operation.off') : (status[0].status_ignicao == 1 ? $t('operation.on') : $t('operation.engineOn')) }}
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="my-2"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ $t('equipStatus.avl.lastValidPositions') }}</strong>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <div v-for="(st, i) in status" :key="`pos-${i}`" style="font-size: smaller;">
                          {{ st.dt_posicao || '-' }} <span class="grey--text">{{ st.qualidade_sinal || '' }}</span>
                        </div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Comunicação por fonte: Merus × Geotab/AVL × FaceID -->
      <v-row v-if="veiculoSelected" no-gutters>
        <v-col cols="12" class="d-flex" style="margin-bottom: 24px;">
          <v-card class="status-card" style="margin-top: 15px; width: 100%;">
            <v-card-title class="d-flex align-center flex-wrap" style="gap: 8px">
              <span class="headline" color="#4a4a4a">{{ $t('equipStatus.vehicleComm.title') }}</span>
              <span v-if="codVeiculoComunicacao" class="subtitle-1 grey--text text--darken-1">
                — {{ $t('equipStatus.vehicleComm.vehicleCode') }}: {{ codVeiculoComunicacao }}
              </span>
              <v-chip
                v-if="resumoComunicacao.divergencia"
                small
                dark
                color="red darken-1"
                class="ml-2"
              >
                {{ $t('equipStatus.vehicleComm.divergence') }}
              </v-chip>
            </v-card-title>
            <v-card-text>
              <div v-if="loadingComunicacao">
                <v-progress-linear color="primary" indeterminate></v-progress-linear>
              </div>
              <v-list v-else dense>
                <v-list-item>
                  <v-list-item-icon class="mr-2 my-auto">
                    <v-icon small :color="corMerus(resumoComunicacao.merusOffline)">
                      {{ iconeMerus(resumoComunicacao.merusOffline) }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <strong>{{ $t('equipStatus.vehicleComm.merus') }}</strong>
                      <span class="ml-2">{{ fmtMerus(resumoComunicacao.merusOffline) }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="resumoComunicacao.dtMerus">
                      {{ fmtDataHora(resumoComunicacao.dtMerus) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon class="mr-2 my-auto">
                    <v-icon small :color="corGeotab(resumoComunicacao.statusGeotab)">
                      {{ iconeGeotab(resumoComunicacao.statusGeotab) }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <strong>{{ $t('equipStatus.vehicleComm.geotab') }}</strong>
                      <span class="ml-2">{{ fmtGeotab(resumoComunicacao.statusGeotab) }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="resumoComunicacao.dtGeotab">
                      {{ fmtDataHora(resumoComunicacao.dtGeotab) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon class="mr-2 my-auto">
                    <v-icon small :color="corFaceid(resumoComunicacao.statusFaceid)">
                      {{ iconeFaceid(resumoComunicacao.statusFaceid) }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <strong>{{ $t('equipStatus.vehicleComm.faceid') }}</strong>
                      <span class="ml-2">{{ fmtFaceid(resumoComunicacao.statusFaceid, resumoComunicacao.temFaceid) }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="resumoComunicacao.dtFaceid">
                      {{ fmtDataHora(resumoComunicacao.dtFaceid) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-card style="margin-top: 15px;">
        <v-card-title>
            <span class="headline" color="#4a4a4a">{{ $t('equipStatus.history.title') }}</span>
        </v-card-title>
        <v-card-text>
            <div v-if="loadingHistorico">
                <v-progress-linear
                    :size="50"
                    color="primary"
                    indeterminate
                ></v-progress-linear>
            </div>
            <div v-else>
                <merus-data-table
                :headers="headersWithProperties"
                :items="historico"
                dense
                class="elevation-7"
                locale="pt"
                :loading="loadingHistorico"
                disable-sort
                :loading-text="$t('equipStatus.loadingHistory')"
                :mobile-breakpoint="0"
                :disable-pagination="true"
                :hide-default-footer="true"
                :fixed-header="true"
                style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px"
                >
                <template v-slot:toolbar>
                  <CadastroToolbar
                    title="Histórico do Equipamento"
                    :token="token"
                    :items="historico"
                    hide-search
                  />
                </template>

                <template v-slot:item.tem_bilhetagem="{ item }">
                  <v-icon :color="getColorIcon(item)">mdi-circle-medium</v-icon>
                </template>

                </merus-data-table>
            </div>
        </v-card-text>
      </v-card>

    </v-container>
  </template>
  
  <script>
  import apiController from '@/utils/apiController';
  import { mapMutations } from "vuex";
  import L from "leaflet";
  import {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
  } from "vue2-leaflet";
  import "leaflet/dist/leaflet.css";
  import DateUtils from "../utils/dateutils";
  import MerusDataTable from "./Tables/MerusDataTable.vue";
  import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
  import translateDbField from "@/utils/translateDbField";
  
  export default {
    components: {
      LMap,
      LTileLayer,
      LMarker,
      LTooltip,
      MerusDataTable,
      CadastroToolbar,
    },
    data: () => ({
      user: null,
      token: null,
      showConfirmButton: true,

      form: true,
      isAtivo: true,
      loadingVeiculos: false,
      loadingStatus: false,
      loadingHistorico: false,
      veiculos: [],
      veiculoSelected: null,
      defaultStatus: {
        numero_ordem: null,
        dt_posicao: null,
        dt_evento: null,
        dt_bilhetagem: null,
        status_validador: null,
        modelo: null,
        numero_serie: null,
        descricao_evento: null,
      },
      status: [{
        numero_ordem: null,
        dt_posicao: null,
        dt_evento: null,
        dt_bilhetagem: null,
        status_validador: null,
        modelo: null,
        numero_serie: null,
        descricao_evento: null,
      }],
      showLocationDialog: false,
      key: 0,
      posicao: null,
      mapOptions: {
        zoomSnap: 0.5,
      },
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentCenter: null,
      historico: [],
      loadingComunicacao: false,
      comunicacaoRows: [],
    }),
    computed: {
      center() {
        return this.$store.getters['config/centerDefault'];
      },
      codVeiculoComunicacao() {
        const daApi = this.comunicacaoRows && this.comunicacaoRows[0] && this.comunicacaoRows[0].cod_veiculo;
        if (daApi) return daApi;
        const veiculo = (this.veiculos || []).find((v) => v.id_veiculo == this.veiculoSelected);
        return veiculo ? (veiculo.cod_veiculo || veiculo.numero_ordem || null) : null;
      },
      resumoComunicacao() {
        const rows = Array.isArray(this.comunicacaoRows) ? this.comunicacaoRows : [];
        const geotab = rows.find((r) => r.fonte === 'GEOTAB') || null;
        const faceid = rows.find((r) => r.fonte === 'FACEID') || null;
        const qualquer = rows[0] || null;
        const merusOffline = qualquer != null
          ? Number(qualquer.gps_offline_merus) === 1
          : null;
        const statusGeotab = geotab ? geotab.status_na_fonte : null;
        const statusFaceid = faceid ? faceid.status_na_fonte : null;
        return {
          merusOffline,
          dtMerus: qualquer ? qualquer.dt_ultima_posicao_merus : null,
          statusGeotab,
          dtGeotab: geotab ? geotab.dt_ultima_comunicacao_fonte : null,
          temGeotab: !!geotab,
          statusFaceid,
          dtFaceid: faceid ? faceid.dt_ultima_comunicacao_fonte : null,
          temFaceid: !!faceid,
          divergencia: merusOffline === true && geotab != null && Number(statusGeotab) === 1,
        };
      },
      headersWithProperties() {
        return this.headers.map(header => ({
          ...header,
          filtrable: true,
          sortable: true
        }));
      },
      today() {
          return new Date().toISOString().substring(0,10);
      },
      messageConfirmButton() {
        return this.$t('button.confirm');
      },
      messageDismissButton() {
        return this.$t('button.dismiss');
      },
      title() {
        return this.status[0].numero_ordem ? this.$t('equipStatus.title') + " " + this.status[0].numero_ordem : this.$t('equipStatus.title')
      },
      numeroOrdemSelected() {
        let veiculo = this.veiculos.find((v) => v.id_veiculo === this.veiculoSelected);
        if (veiculo) {
          return veiculo.numero_ordem;
        }

        return null;
      },
      headers() {
        return [
          { text: this.$t('relTimePlate.headersPlateTime.id'), value: "id_veiculo", align: " d-none" },
          { text: this.$t('equipStatus.history.headers.date'), value: "dia_extenso" },
          { text: this.$t('equipStatus.history.headers.sendPercentage'), value: "p_envio" },
          { text: this.$t('equipStatus.history.headers.invalidPercentage'), value: "p_invalidas" },
          { text: this.$t('equipStatus.history.headers.ticketing'), value: "tem_bilhetagem" }]
      },
      cod() {
        return this.$route.params.cod;
      }
    },
    watch: {
      '$i18n.locale'() {
        this.initialize();
      }
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.token = sessionStorage.getItem("api");
      this.initialize();
    },
    mounted() {},
    methods: {
    ...mapMutations('timeout', [
        'resetStatus'
      ]),
      initialize() {
        this.currentCenter = this.center;
        this.status = [this.defaultStatus];
        this.populaVeiculos();
      },
      populaStatus() {
        this.loadingStatus = true;
        apiController.request(apiController.endpoints.getStatusveiculo, {
          params: { id: this.veiculoSelected },
          onSuccess: (response) => {
            if (Array.isArray(response.data)) {
              this.status = response.data.map((s) => {
                const translated = translateDbField(
                  s.status_validador_translation_key,
                  s.status_validador
                );
                return {
                  ...s,
                  status_validador: translated
                };
              });
            } else {
              this.status = [this.defaultStatus];
            }
            this.loadingStatus = false;
            this.resetStatus(setTimeout(() => {
              this.populaStatus();
              this.populaComunicacao();
            }, 30000));
          },
          onError: () => {
            this.loadingStatus = false;
            this.status = [this.defaultStatus];
          },
        });
      },
      populaHistorico() {
        this.loadingHistorico = true;
        let d = new Date();
        d.setDate(d.getDate() - 1);
        d.setMonth(d.getMonth() - 1);

        let body = {
          ids: this.veiculoSelected,
          dti: DateUtils.getDateSQLFormatted(d)
        };
        apiController.request(apiController.endpoints.getHistoricoveiculoequipamento, {
          data: body,
          onSuccess: (response) => {
            this.historico = response.data;
            this.loadingHistorico = false;
          },
          onError: () => {
            this.loadingHistorico = false;
          },
        });
      },
      populaConsulta() {
        if (this.$refs.form.validate() || this.cod) {
          this.populaStatus();
          this.populaHistorico();
          this.populaComunicacao();
        }
      },
      populaComunicacao() {
        if (!this.veiculoSelected) {
          this.comunicacaoRows = [];
          return;
        }
        this.loadingComunicacao = true;
        apiController.request(apiController.endpoints.getStatuscomunicacaoequipamentosporveiculo, {
          query: { id_veiculo: this.veiculoSelected },
          silent: true,
          onSuccess: (response) => {
            this.comunicacaoRows = response.data || [];
            this.loadingComunicacao = false;
          },
          onError: () => {
            this.comunicacaoRows = [];
            this.loadingComunicacao = false;
          },
        }).catch(() => {
          this.comunicacaoRows = [];
          this.loadingComunicacao = false;
        });
      },
      fmtDataHora(valor) {
        if (!valor) return '';
        const partes = String(valor).replace('T', ' ').split(' ');
        const data = (partes[0] || '').split('-');
        if (data.length !== 3) return String(valor);
        const hora = partes[1] ? ` ${partes[1]}` : '';
        return `${data[2]}/${data[1]}/${data[0]}${hora}`;
      },
      fmtMerus(offline) {
        if (offline == null) return this.$t('equipStatus.vehicleComm.na');
        return offline
          ? this.$t('equipStatus.vehicleComm.offline')
          : this.$t('equipStatus.vehicleComm.online');
      },
      corMerus(offline) {
        if (offline == null) return 'grey';
        return offline ? 'red' : 'green';
      },
      iconeMerus(offline) {
        if (offline == null) return 'mdi-help-circle';
        return offline ? 'mdi-close-circle' : 'mdi-check-circle';
      },
      fmtGeotab(valor) {
        if (valor == null || valor === '') return this.$t('equipStatus.vehicleComm.noEquipment');
        if (Number(valor) === 1) return this.$t('equipStatus.vehicleComm.online');
        if (Number(valor) === 0) return this.$t('equipStatus.vehicleComm.offline');
        return this.$t('equipStatus.vehicleComm.na');
      },
      corGeotab(valor) {
        if (valor == null || valor === '') return 'grey';
        if (Number(valor) === 1) return 'green';
        if (Number(valor) === 0) return 'red';
        return 'grey';
      },
      iconeGeotab(valor) {
        if (valor == null || valor === '') return 'mdi-help-circle';
        if (Number(valor) === 1) return 'mdi-check-circle';
        if (Number(valor) === 0) return 'mdi-close-circle';
        return 'mdi-help-circle';
      },
      fmtFaceid(valor, temEquipamento) {
        if (!temEquipamento) return this.$t('equipStatus.vehicleComm.noEquipment');
        if (Number(valor) === 1) return this.$t('equipStatus.vehicleComm.online');
        if (Number(valor) === 2) return this.$t('equipStatus.vehicleComm.offline');
        return this.$t('equipStatus.vehicleComm.unknown');
      },
      corFaceid(valor) {
        if (valor == null || valor === '') return 'grey';
        if (Number(valor) === 1) return 'green';
        if (Number(valor) === 2) return 'red';
        return 'grey';
      },
      iconeFaceid(valor) {
        if (valor == null || valor === '') return 'mdi-help-circle';
        if (Number(valor) === 1) return 'mdi-check-circle';
        if (Number(valor) === 2) return 'mdi-close-circle';
        return 'mdi-help-circle';
      },
      populaVeiculos() {
        this.loadingVeiculos = true;
        apiController.request(apiController.endpoints.getallVeiculosativos, {
          onSuccess: (response) => {
            this.veiculos = response.data;
            this.loadingVeiculos = false;
            if (this.cod) {
              let veiculo = this.veiculos.find((v) => v.numero_ordem === this.cod);
              if (veiculo) {
                this.veiculoSelected = veiculo.id_veiculo;
                this.populaConsulta();
              }
            }
          },
          onError: () => {
            this.loadingVeiculos = false;
          },
        });
      },
      statusStyle(status) {
        if (status == this.$t('equipStatus.commercial')) {
            return {color: "green"};
        } else {
            return {color: "red"};
        }
      },
      onMapPlotagemResize() {
        this.$refs.map.mapObject.invalidateSize();
      },
      showLocation() {
        this.key = this.key === 0 ? 1 : 0;
        this.posicao = L.latLng(this.status[0].lat, this.status[0].lng);
        this.currentCenter = [parseFloat(this.status[0].lat), parseFloat(this.status[0].lng)];
        this.showLocationDialog = true;
      },
      closeLocationDialog() {
        this.posicao = null;
        this.currentCenter = [-22.88746, -43.29185];
        this.showLocationDialog = false;
      },
      getColorIcon(item) {
        if (item.tem_bilhetagem == 1) {
          return "green";
        }

        return "red";
      }
    },
  };
  </script>
  